import { render, staticRenderFns } from "./integrations_page.vue?vue&type=template&id=273b15a0&scoped=true&"
import script from "./integrations_page.vue?vue&type=script&lang=js&"
export * from "./integrations_page.vue?vue&type=script&lang=js&"
import style0 from "./integrations_page.vue?vue&type=style&index=0&id=273b15a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b15a0",
  null
  
)

export default component.exports